import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { IconYotiIcon } from '@yoti/ui-kit-components-react/icons';
import { BUTTON_SIZES } from '@yoti/ui-kit-components-react/button';
import SkinnedButton from '../SkinnedButton'

import './ShareButton.scss'

const ShareButton = ({
  onClick,
  children,
  disabled,
  icon
}) => (
  <div className={classnames('share-button', { 'share-button--disabled': disabled })}>
    <SkinnedButton text={children} onClick={onClick} size={BUTTON_SIZES.MEDIUM} fullWidth iconStart={icon} disabled={disabled} />
  </div>
)

ShareButton.defaultProps = {
  children: null,
  disabled: true,
  icon: <IconYotiIcon />
}

ShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element
  ]),
  disabled: PropTypes.bool,
  icon: PropTypes.element,
}

export default ShareButton
